import {
  EntrancePlantDetailDTO,
  EntrancePlantInfoCreateDTO,
  EntrancePlantStructureCreateDTO,
} from '@/../client-generator/generated-clients/plants';
import { mapState } from 'vuex';
import { Options, Vue } from 'vue-class-component';
import { validLanguages } from '@/core/utils/utils';
import plantsClient from '@/core/services/plants';
import { SET_APP_LOADING } from '@/core/store/action-types';

@Options({
  name: 'DeviceLanguageTab',
  props: {
    infoPlant: {
      type: EntrancePlantInfoCreateDTO,
      required: true,
    },
  },
  computed: {
    ...mapState(['currentEntrancePlant']),
  },
  components: {},
  emits: ['update-list'],
})
export default class DeviceLanguageTab extends Vue {
  currentEntrancePlant!: EntrancePlantDetailDTO;
  validLanguages = validLanguages;
  infoPlant!: EntrancePlantDetailDTO;
  editedInfoPlant: EntrancePlantDetailDTO = new EntrancePlantInfoCreateDTO();

  mounted() {
    this.initializeData();
  }

  initializeData() {
    this.editedInfoPlant = new EntrancePlantInfoCreateDTO({
      language: this.infoPlant.language,
    });
  }

  get saveDisabled() {
    return this.editedInfoPlant.language === this.infoPlant.language || this.currentEntrancePlant.syncStatus?.isPlantActive;
  }

  async handleChangeLanguage() {
    this.$store.dispatch(SET_APP_LOADING, true);
    await this.saveLanguage();
    this.$emit('update-list');
 
    this.$store.dispatch(SET_APP_LOADING, false);
  }

  async saveLanguage() {
    if (this.currentEntrancePlant.desktopId === undefined) return;
    try {
      this.infoPlant.language = this.editedInfoPlant.language;

      await plantsClient.editinfo(
        this.currentEntrancePlant.desktopId,
        this.infoPlant
      );
    } catch (error) {
      console.log(error);
      setTimeout(() => {
        this.$toast.add({
          severity: 'error',
          summary: 'Error',
          closable: false,
          life: 3000,
        });
      }, 1500);
    }
  }
}
